import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import * as UserDataConfig from '../../pages/user-details/config/user-data.config';
import { UtilityServiceForMedicalService } from 'src/app/pages/medical-underwriting/services/utility-service';
/** S changes */
import { UntypedFormGroup } from '@angular/forms';

import { LifeStyleQuestion, Sections } from 'src/app/pages/medical-underwriting/model/lifestyle.model';
import { Tooltip } from 'src/app/model/tooltip';
import { SyncService } from '../../pages/medical-underwriting/services/sync.service';
import { ErrorMsgModel } from 'src/app/pages/medical-underwriting/model';
import { UntypedFormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { UtilService, AnalyticsService } from '../../shared';
// tslint:disable-next-line:import-spacing
import { EmitterToCtlTypeModel, AccordQuestionStoreModel, MedicationQuestionStoreModel }
  from 'src/app/pages/medical-underwriting/model/mcUserJourney.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-toggle-standard',
  templateUrl: './toggle-standard.component.html',
  styleUrls: ['./toggle-standard.component.scss']
})
export class ToggleStandardComponent implements OnInit, OnDestroy {


  @Input() question: LifeStyleQuestion;
  @Input() parent: UntypedFormGroup;
  controlName: string;
  @Input() indexToAppend: number;
  @Input() objToReferToRetainValueFromTabSquare: MedicationQuestionStoreModel;
  @Input() objToReferForAccord: AccordQuestionStoreModel;
  @Input() accordIndexToAppend: number;
  @Input() editMode: boolean;
  domId: string;
  selectedOptions: LifeStyleQuestion[] = [];
  label1test: string;
  label2test: string;
  selectedLbl: string;
  patternErrorMessage: string = '';
  focusOnLblOne: string[];
  focusOnLblTwo: string[];
  switchLblOne: string[];
  switchLblTwo: string[];
  tooltipObj: Tooltip;
  rangeValidationData: any;
  errorValue: ErrorMsgModel;
  checkErrorMsg: boolean = false;
  isValueStored: boolean = false;
  selectedOptionsNew: LifeStyleQuestion[] = [];
  subscription: any;

  @Output() toggleOptionHandler: EventEmitter<any> = new EventEmitter();
  @Output() editModelHandler: EventEmitter<any> = new EventEmitter();
  @Output() onDisplayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();
  protected userInputDetail = UserDataConfig.ElementsConfig;
  protected healthAndLifestyleConfig = Object.assign({}, this.userInputDetail.healthAndLifestyleConfig);

  private toggleFlag = false;
  public nextSections;

  constructor(private utilityServiceForMedicalService: UtilityServiceForMedicalService,
    private fb: UntypedFormBuilder, private syncService: SyncService, private utilService: UtilService,
    private analyticsService: AnalyticsService, private router: Router) {

  }


  ngOnInit() {
    this.domId = this.utilityServiceForMedicalService.getDomId(this.question.id, this.accordIndexToAppend, this.indexToAppend);
    this.controlName = this.utilityServiceForMedicalService.getControlName(this.question.id, this.accordIndexToAppend);
    if (this.objToReferForAccord) {
      this.question.responseValueByUser = this.utilityServiceForMedicalService.getResponseValueFromRefObj(this.objToReferForAccord, this.question.id, this.accordIndexToAppend);
    }
    this.initializeToggleBtn();
    this.initializeInfoText();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.toggleOptionHandler.emit(new EmitterToCtlTypeModel(this.selectedLbl, false, this.objToReferToRetainValueFromTabSquare, this.accordIndexToAppend, this.objToReferForAccord, true));
    }, 300);
  }
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  initializeToggleBtn() {
    this.label1test = this.question.responseValue[0] ? this.question.responseValue[0] : "";
    this.label2test = this.question.responseValue[1] ? this.question.responseValue[1] : "";
    let selectedValue = this.question.responseValueByUser ? this.question.responseValueByUser : this.question.defaultResponseValue;
    this.selectedLbl = selectedValue;
    this.setFocus(selectedValue);
    this.setValueForLabelInForm(this.question, selectedValue);
  }

  initializeInfoText() {
    this.tooltipObj = new Tooltip(this.question.helpText, '', false);
  }

  setFocus(value: string) {
    if (value === this.label1test) {
      this.focusOnLblOne = ["switch-handle"];
      this.focusOnLblTwo = ["switch-focus"];
      this.switchLblOne = ["on"];
      this.switchLblTwo = ["off"];
    }
    else {
      this.focusOnLblOne = ["switch-focus"];
      this.focusOnLblTwo = ["switch-handle"];
      this.switchLblOne = ["off"];
      this.switchLblTwo = ["on"];
    }

  }
  /* conversion and error parton toggle*/
  changeSelection(toggleSelected: string, validationRequired: boolean): boolean {
    let conversionLogicApplied = false;
    this.selectedOptions = [];
    this.question.nextStep.forEach(next => {
      if (next.nextStepSelectedResponse === toggleSelected) {
        this.selectedOptions = this.utilityServiceForMedicalService.getQuestionListForGivenIds(next.nextStepValue, null);
      }
    });

    if (validationRequired) {
      this.isInvalidPattern();
      this.question.nextStep.forEach(next => {
        if (next.nextStepSelectedResponse === toggleSelected) {
          this.selectedOptions.forEach(option => {
            if (this.parent && !this.parent.controls[option.id]) {
              this.parent.addControl(option.id, this.fb.control(null, Validators.required));
            }
          });
          let nextQuestionsForConversion = [];
          nextQuestionsForConversion.push(this.question.id);
          this.question.nextStep.forEach(element => {
            nextQuestionsForConversion = nextQuestionsForConversion.concat(element.nextStepValue);
          });

          for (const cont in this.parent.controls) {
            if (this.parent.controls.hasOwnProperty(cont) && (nextQuestionsForConversion.includes(cont))) {
              this.selectedOptionsNew = [];

              this.selectedOptionsNew = this.utilityServiceForMedicalService.getQuestionListForGivenIds([cont], null);
              const errorValue = this.utilityServiceForMedicalService.isInvalidPattern(this.parent, this.selectedOptionsNew);

              this.selectedOptionsNew.forEach(question => {
                if (question.origoElement === 'height') {
                  this.utilityServiceForMedicalService.conversionChangesForHeight(question, this.parent, errorValue, toggleSelected);
                  conversionLogicApplied = true;
                }
                else if (question.origoElement === 'weight') {
                  this.utilityServiceForMedicalService.conversionChangesForWeight(question, this.parent, errorValue, toggleSelected);
                  conversionLogicApplied = true;
                } else if (question.origoElement === 'result') {
                  this.utilityServiceForMedicalService.conversionChangesForDiabetes(question, this.parent, errorValue, toggleSelected);
                  conversionLogicApplied = true;
                }
              });

            }
          }
          /* conversion change ends*/
          if (this.errorValue && this.errorValue.errorMessage) {
            this.errorValue.errorMessage = '';
            this.checkErrorMsg = false;
            for (const cont in this.parent.controls) {
              if (this.parent.controls.hasOwnProperty(cont)) {
                let tempControl = this.parent.controls[cont];
                if (tempControl.value) {
                }
                if (tempControl.errors && tempControl.errors.pattern && tempControl.errors.pattern !== null) {
                  tempControl.errors.pattern = '';
                  break;
                }
              }
            }
          }
        }
      });
    }
    return conversionLogicApplied;
  }


  emitToggleOptions(option: string) {
    if (this.editMode) {
      const payload = {
        value: option,
        screen: 'toggle'
      };
      if (!this.subscription) {
        this.subscription = this.utilService.updateEditForm.subscribe(res => {
          if (res && res.screen === 'toggle') {
            this.editMode = false;
            this.emitToggleOptions(res.value);
          }
        });
      }
      this.editModelHandler.emit(payload);
    } else {
      this.setFocus(option);
      this.setValueForLabelInForm(this.question, option);
      let conversionLogicApplied = false; // Disabling conversion Logic for Phase 1.
      // this.changeSelection(option, true)
      let resetNextQuestion: boolean = true; // Disabling conversion Logic for Phase 1. // default we should keep it as false to reset when user change the toggle
      // (conversionLogicApplied === true) ? false: true
      this.toggleOptionHandler.emit(new EmitterToCtlTypeModel(option, resetNextQuestion, this.objToReferToRetainValueFromTabSquare, this.accordIndexToAppend, this.objToReferForAccord, true));
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
  }
  setValueForLabelInForm(question: LifeStyleQuestion, option: string) {
    if (this.parent.controls[question.id]) {
      this.parent.controls[question.id].setValue(option);
    }
    else {
      this.parent.addControl(question.id, this.fb.control(null, Validators.required));
      this.parent.controls[question.id].setValue(option);
    }
    this.question.responseValueByUser = option;
  }

  onChange(data, option: LifeStyleQuestion) {
    option.responseValueByUser = data;
    this.isInvalidPattern();
    this.checkErrorMsg = this.isInvalidPattern()
  }
  isInvalidPattern(): boolean {
    this.errorValue = this.utilityServiceForMedicalService.isInvalidPattern(this.parent);
    return this.errorValue.isValid;

  }
  errorValidation = () => {
    let valid = true;
    this.question.nextStep.forEach(next => {
      next.nextStepValue.forEach(nextStep => {
        const control = this.parent.get(nextStep).value;
        if (!control) {
          valid = false;
        }
      });
      if (!valid) {
        this.parent.get(this.question.id).setErrors({ required: true });
      } else {
        this.parent.get(this.question.id).setErrors(null);
      }
    });
  }

  isMultipleBox(): boolean {
    if (this.question.controlStyle === 'InputBox_2numbers' ||
      this.question.controlStyle === 'InputBox_3numbers') {
      return true;
    }
    else {
      return false;
    }
  }

  lifestyleInfoReceiver(value: LifeStyleQuestion) {
    if (value && this.utilityServiceForMedicalService.isPartOfWA(value.questionText)) {
      this.analyticsService.eventTrack({ type: 'Question', name: value.questionText, pageID: this.getCurrentScreenURL() });
    }
  }

  getCurrentScreenURL() {
    let screenName = this.utilService.getScreenNameFromURL(this.router.url);
    return screenName;
  }
  
  displayMobileTooltipReceiver(){
    this.onDisplayMobileTooltipEmitter.emit();
  }
}
